module.exports = __webpack_public_path__ + "img/ltecredentials.2d4a3243.png";